(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/bankid/assets/javascripts/bankid.js') >= 0) return;  svs.modules.push('/components/app/bankid/assets/javascripts/bankid.js'); (function(svs) {
  var ACTION_TYPE = {
    SUSPENSION: 0,
    SUBSCRIPTION: 1
  };
  const { Confirm, message, api } = svs.ui.dialog;

  function bankidErrorHandler(actionType, xhr, failEvent) {
    var errorCode;
    var errorMessage;
    if (svs.utils.ns.isNamespace('responseJSON.error.code', xhr || {})) {
      errorCode = xhr.responseJSON.error.code;
    }
    switch (errorCode) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 8:
      case 9:
      case 10:
      case 12:
      case 13:
      case 14:
      case 15:
      case 18:
      case 19:
      case 20:
      case 41:
      case 42:
      case 43:
      case 46:
      case 47:
      case 48:
      case 49:
      case 53:
      case 54:
      case 55:
        if (actionType === ACTION_TYPE.SUSPENSION) {
          errorMessage =
            'Det går inte att verifiera din identitet just nu, var vänlig försök igen lite senare.';
        } else {
          errorMessage =
            'Det går inte att skapa autogiromedgivande just nu, var vänlig försök igen lite senare.';
        }
        break;
      case 56:
        errorMessage =
          'BankID-appen svarar inte. Kontrollera att den är startad och att du har internetanslutning. Om du inte har något giltigt BankID kan du hämta ett hos din internetbank. Försök sedan igen.';
        break;
      case 7:
      case 11:
      case 16:
      case 17:
        if (actionType === ACTION_TYPE.SUSPENSION) {
          errorMessage =
            'Kan inte verifiera din identitet, var vänlig kontakta Kundservice 0770 - 11 11 11';
        } else {
          errorMessage =
            'Kan inte skapa autogiromedgivande, var vänlig kontakta Kundservice 0770 - 11 11 11';
        }
        break;
      case 44:
        if (actionType === ACTION_TYPE.SUSPENSION) {
          errorMessage =
            'Det går inte att verifiera din identitet just nu, prova att uppdatera BankID appen.';
        } else {
          errorMessage =
            'Det går inte att skapa autogiromedgivande just nu, prova att uppdatera BankID appen.';
        }
        break;
      case 45:
        errorMessage =
          'Det BankID du försöker använda är för gammalt eller spärrat. Använd ett annat BankID eller hämta ett nytt hos din internetbank';
        break;
      case 50:
        if (actionType === ACTION_TYPE.SUSPENSION) {
          errorMessage = 'Verifiering avbruten, var vänlig försök igen';
        } else {
          errorMessage =
            'Skapandet av autogiromedgivande avbruten, var vänlig försök igen';
        }
        break;
      case 51:
      case 52:
        svs.app.bankid.logger.debug('User cancelled');
        var message = '';
        var type;
        if (actionType === ACTION_TYPE.SUSPENSION) {
          message = 'Bekräftelse av spelpaus avbröts';
          type = svs.ui.dialog.area.POPUP;
        } else {
          message = 'Skapandet av autogiromedgivande avbröts';
          type = svs.ui.dialog.area.TOASTER;
        }
        var errorDialog = new svs.ui.dialog.Confirm({
          area: type,
          branding: svs.ui.dialog.branding[svs.core.detect.tenant('lb') ? 'SPORT' : 'TUR'],
          type: svs.ui.dialog.type.ERROR,
          title: message,
          actions: [
            {
              title: 'OK'
            }
          ]
        });
        svs.ui.dialog.api.add(errorDialog);
        if (failEvent) {
          svs.components.analytics.trackEvent(failEvent);
        }
        break;
      default:
        svs.app.bankid.logger.error('Unhandled bankid error', xhr);
        if (actionType === ACTION_TYPE.SUSPENSION) {
          errorMessage =
            'Det går inte att verifiera din identitet just nu, var vänlig försök igen lite senare.';
        } else {
          errorMessage =
            'Det går inte att skapa autogiromedgivande just nu, var vänlig försök igen lite senare.';
        }
    }
    if (errorMessage) {
      var loggerInfo = '';
      var title = '';
      if (actionType === ACTION_TYPE.SUSPENSION) {
        loggerInfo = 'Suspension request with bankid failure';
        title = 'Misslyckad verifiering';
      } else {
        loggerInfo = 'Direct debit permission request with bankid failure';
        title = 'Misslyckat autogiromedgivande';
      }
      svs.app.bankid.logger.info(loggerInfo);
      var standardErrorDialog = new svs.ui.dialog.Confirm({
        branding: svs.ui.dialog.branding.TUR,
        type: svs.ui.dialog.type.ERROR,
        title: title,
        message: [
          {
            type: svs.ui.dialog.message.TEXT,
            text: errorMessage
          }
        ],
        actions: [
          {
            title: 'OK'
          }
        ]
      });
      svs.ui.dialog.api.add(standardErrorDialog);
    }
  }

  function showBankIDProgress(options, successFn, errorFn, context, successEvent, response) {
    var checker = new svs.app.bankid.Checker({
      autoStartToken: response.autoStartToken
    });
    const confirmDialog = new Confirm({
      branding: svs.ui.dialog.branding[svs.utils.branding.siteWide()],
      icon: 'mobile',
      allowDimmerClick: false,
      title: options?.title ? options.title : 'BankID',
      message: [
        {
          type: message.TEXT,
          text: 'Försöker starta BankID-appen.',
          align: message.align.CENTER
        },
        {
          type: svs.ui.dialog.message.TEXT,
          text: '<div class="js-loader-container relative"></div>',
          align: svs.ui.dialog.message.align.CENTER
        }
      ],
      actions: [
        {
          title: 'AVBRYT',
          callback: () => {
            checker.stopPolling();
            errorFn.call(context, {
              responseJSON: {
                error: {
                  code: 51
                }
              }
            });
            confirmDialog.close();
          }
        },
        {
          title: 'ÖPPNA BANK-ID APPEN',
          callback: () => {
            checker.startPolling();
          }
        }
      ]
    });
    setTimeout(() => {
      const loader = new svs.ui.Loader('.js-loader-container');
      loader.show(200, 'inverted');
    }, 100);
    checker.startPolling();
    api.add(confirmDialog);

    checker.model.once('change:postToken', function(model, value) {
      confirmDialog.close();
      successFn && successFn.call(context, { postToken: value });
      if (successEvent) {
        svs.components.analytics.trackEvent(successEvent);
      }
    });
    checker.model.once('change:error', function(model, value) {
      confirmDialog.close();
      errorFn.call(context, value);
    });
  }
  function authenticate(options, successFn, errorFn, context, successEvent, failEvent) {
    var errFn =
      errorFn ||
      function(xhr) {
        bankidErrorHandler(ACTION_TYPE.SUSPENSION, xhr, failEvent);
      };
    options = options || {};
    options.title = options.title || 'Bekräfta spelpaus';
    svs.core.jupiter.call(
      {
        path: '/player/1/authenticatesign',
        method: 'POST',
        data: {},
        context: this
      },
      showBankIDProgress.bind(this, options, successFn, errFn, context, successEvent),
      errFn
    );
  }
  function createDirectDebitPermission(options, successFn, errorFn, context) {
    var errFn =
      errorFn ||
      function(xhr) {
        bankidErrorHandler(ACTION_TYPE.SUBSCRIPTION, xhr);
      };
    options = options || {};
    options.title = options.title || 'Autogiromedgivande';
    svs.core.jupiter.call(
      {
        path: '/player/1/sign',
        method: 'POST',
        data: {
          bankAccount: options.bankAccount,
          bankName: options.bankName
        },
        context: this
      },
      showBankIDProgress.bind(this, options, successFn, errFn, context, undefined),
      errFn
    );
  }
  svs.app.bankid.suspensionDefaultErrorHandler = bankidErrorHandler.bind(
    this,
    ACTION_TYPE.SUSPENSION
  );
  svs.app.bankid.subscriptionDefaultErrorHandler = bankidErrorHandler.bind(
    this,
    ACTION_TYPE.SUBSCRIPTION
  );
  svs.app.bankid.verifySuspensionRequest = authenticate;
  svs.app.bankid.createDirectDebitPermission = createDirectDebitPermission;
})(svs);

 })(window);